import React from 'react';
import { connect } from 'react-redux';
import { PageLoader, TabContainer } from '@kambria/kambria-lego';
import LoadingButton from 'views/components/LoadingButton';
import { getCreditsHistory } from 'redux/actions/credit.action';

const INITAL_LIMIT = 5;
const PAGE = 1;

class Credit extends React.Component {
  componentDidMount() {
    const { getCreditsHistory: getCreditsHistoryList, credit } = this.props;
    const { page = PAGE } = credit.pagination;
    getCreditsHistoryList(INITAL_LIMIT, page);
  }

  onLoadMore = () => {
    const { getCreditsHistory: getCreditsHistoryList, credit } = this.props;
    return getCreditsHistoryList(INITAL_LIMIT, credit.pagination.page + 1);
  };

  renderContent = () => {
    const { credit } = this.props;
    const style = {
      whiteSpace: 'nowrap',
    };
    return credit.history.map((item, index) => {
      return (
        <tr key={index}>
          <td className="w-25 pr-2" style={style}>
            {new Date(item.createdAt).toDateString().slice(4)}
          </td>
          <td className="w-25 pr-2" style={style}>
            {item.amount}
          </td>
          <td className="w-100 pr-2" style={style}>
            {this.getDescription(item)}
          </td>
        </tr>
      );
    });
  };

  getDescription = (history) => {
    const { additionalData = {}, bounty } = history;
    const note = history.note || '';
    if (!note.includes('this activity')) {
      return note;
    }
    let description = note;
    const { bountyId, productId, edukationUrl, name, productName } = additionalData;
    let href, text;
    if (bountyId) {
      href = `/bounty/${additionalData.bountyId}`;
      text = (bounty && bounty.name) || 'this activity';
    }
    if (productId && edukationUrl) {
      href = edukationUrl;
      text = name || productName || 'this activity';
    }
    const noteParts = note ? note.split('this activity') : [];
    description = (
      <span>
        {noteParts[0]}
        <a href={href} target="_blank" rel="noopener noreferrer">
          {text}
        </a>
        {noteParts[1]}
      </span>
    );
    return description;
  };

  render() {
    const { credit } = this.props;
    const { history, pagination, loading } = credit;
    const { limit, total, page } = pagination;
    const showLoadMore = limit * page < total;
    if (!history.length && loading)
      return (
        <div className="tab-content">
          <TabContainer className="container px-0 mt-3">
            <div className="table-responsive">
              <PageLoader type="position" />
            </div>
          </TabContainer>
        </div>
      );
    return (
      <div className="tab-content">
        <TabContainer className="container px-0 mt-3">
          <div className="table-responsive">
            <table className="w-100 table">
              <thead>
                <tr>
                  <th className="pr-2" scope="col">
                    Date
                  </th>
                  <th className="pr-2" scope="col" style={{ width: '13%' }}>
                    Value
                  </th>
                  <th className="pr-2" scope="col" style={{ width: '70%' }}>
                    Description
                  </th>
                </tr>
              </thead>
              <tbody>{this.renderContent()}</tbody>
            </table>
          </div>
          {showLoadMore && (
            <div style={{ textAlign: 'center' }}>
              <LoadingButton onClick={this.onLoadMore} loading={loading} variant="gray" size="sm">
                Load more
              </LoadingButton>
            </div>
          )}
        </TabContainer>
      </div>
    );
  }
}

const mapStateToProps = ({ credit }) => ({ credit });

export default connect(mapStateToProps, { getCreditsHistory })(Credit);
